<template>
  <div>
  <Modal
    v-model="ProjectShow"
     :title="actionType === 'add' ? $t('message.project.createProject') : $t('message.project.editorProject')"
     :closable="false" :mask-closable="false">
    <Form
      :label-width="100"
      label-position="left" 
      ref="projectForm"
      :model="projectDataCurrent"
      :rules="formValid"
      v-if="ProjectShow">
      <FormItem
        :label="$t('message.project.projectName')"
        prop="name">
        <Input
          v-model="projectDataCurrent.name"
          :placeholder="$t('message.newConst.enterName')"
          :disabled="actionType === 'modify'"/>
      </FormItem>
      <FormItem
        :label="$t('message.project.product')"
        prop="product">
        <Input
          v-model="projectDataCurrent.product"
          :placeholder="$t('message.newConst.enterName')"/>
      </FormItem>
      <FormItem
        :label="$t('message.project.appArea')"
        prop="applicationArea">
        <Select
          v-model="projectDataCurrent.applicationArea"
          :placeholder="$t('message.project.selectAppArea')">
          <Option
            v-for="(item, index) in applicationAreaMap"
            :label="item"
            :value="index"
            :key="index"/>
        </Select>
      </FormItem>
      <FormItem
        :label="$t('message.project.business')"
        prop="business">
        <we-tag
          :new-label="$t('message.project.addBusiness')"
          :tag-list="projectDataCurrent.business"
          @add-tag="addTag"
          @delete-tag="deleteTag"></we-tag>
      </FormItem>
      <FormItem
        :label="$t('message.project.projectDesc')"
        prop="description">
        <Input
          v-model="projectDataCurrent.description"
          type="textarea"
          :placeholder="$t('message.project.pleaseInputProjectDesc')"/>
      </FormItem>
      <FormItem
        label="预警用户"
        prop="warningUser">
        <div class="tblUptPadding">
          <Table size="small"  :columns="warningUsercolumn" :data="warningUserData" >
            <template slot-scope="{ row, index }" slot="action" >
                <a class="a-margin-right" @click="addWarningUser()"><Icon type="ios-add" size="18" title="添加"/></a>
                <a class="a-margin-right" @click="editWarningUser(row,index)"><Icon type="ios-create-outline" size="18" title="编辑"/></a>
                <a @click="deleteWarningUser(row,index)"><Icon type="ios-trash-outline" size="18" title="删除"/></a>
            </template>   
          </Table>
        </div>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button
        type="text"
        size="large"
        @click="Cancel">{{$t('message.newConst.cancel')}}</Button>
      <Button
        type="primary"
        size="large"
        @click="Ok">{{$t('message.newConst.ok')}}</Button>
    </div>
  </Modal>
  <!-- 预警成员的新建和修改modal -->
  <Modal v-model="warningUserModal"  title="预警用户" :closable="false" :mask-closable="false" >
      <Form :label-width="100"  ref="warningUserForm" :model="warningUserInfo" :rules="warningUserValid" >
        <FormItem label="用户" prop="name">
          <Input v-model="warningUserInfo.name" placeholder="请输入预警用户工号" v-if="addWarningUserFlag==false" disabled/>
          <Select v-model="warningUserInfo.name" placeholder="请选择预警用户" :filterable=true v-else >
              <Option v-for="item in userIds" :value="item" :key="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input v-model="warningUserInfo.email" type="email" placeholder="请输入预警用户邮箱"/>
        </FormItem>
        <FormItem label="手机号" prop="phone">
          <Input v-model="warningUserInfo.phone" type="tel" placeholder="请输入预警用户手机号"/>
        </FormItem>
        <FormItem label="微信" prop="wechat">
          <Input v-model="warningUserInfo.wechat" type="text" placeholder="请输入预警用户微信号"/>
        </FormItem>
      </Form>
      <div slot="footer">
      <Button type="text" size="large" @click="warningUserCancel">{{$t('message.newConst.cancel')}}</Button>
      <Button type="primary" size="large" @click="warningUserConfirm">{{$t('message.newConst.ok')}}</Button>
    </div>
  </Modal>
</div>

</template>
<script>
import api from '@dss/js/service/api';

import tag from '@dss/js/component/tag/index.vue';
import expandRow from '@dss/js/module/project/module/expandTable.vue';


export default {
  components: {
    'we-tag': tag,
    'expandRow':expandRow,
  },
  props: {
    projectData: {
      type: Object,
      default: null,
    },
    addProjectShow: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      warningUserModal:false,
      warningUserInfo:{}, // 预警用户对象
      addWarningUserFlag:false, // 修改or新建预警用户
      updateWarningUserIndex:-1, // 在编辑的对象的index
      userIds:[], // 新建窗口中预警用户下拉
      // 预警用户
      warningUsercolumn: [
        {
            type: 'expand',
            width: 20,
            render: (h, params) => {
                return h(expandRow, {
                    props: {
                        row: params.row
                    }
                })
            }
        },
        {
            title: '用户',
            key: 'name',
            width: 100,
            align:'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            title: '邮箱',
            key: 'email'
        },
        {
            title: '操作',
            slot: 'action',
            width:90,
            align: 'left'
        }
      ],
      warningUserData:[
          {'name':'014334aa','email':'aaaa.xian@haier.com','phone':"12345678912",'wechat':"aaabbbccc"},{'name':'014334aa','email':'aaaa.xian@haier.com','phone':"12345678912",'wechat':"aaabbbccc"}],
      ProjectShow: false,
      // formValid: {
      //     name: [
      //         { required: true, message: '请输入名称', trigger: 'blur' },
      //         { message: '名称长度不能大于20', max: 20 },
      //         { type: 'string', pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: '必须以字母开头，且只支持字母、数字、下划线！', trigger: 'blur' },
      //     ],
      //     description: [
      //         { required: true, message: '请输入工程描述', trigger: 'blur' },
      //     ],
      //     product: [
      //         { required: true, message: '请选择产品', trigger: 'change' },
      //     ],
      //     applicationArea: [
      //         { required: true, message: '请选择应用领域', trigger: 'change' },
      //     ],
      // },
      applicationAreaMap: [],
      originBusiness: '',
    };
  },
  computed: {
    warningUserValid(){
      return{
        name:[{required: true, message: '请输入预警用户手机号', trigger: 'blur'}],
        email:[{required: true, message: '请输入预警用户邮箱', trigger: 'blur'}],
        phone:[{required: true, message: '请输入预警用户电话', trigger: 'blur'}],
      }
    },
    projectDataCurrent() {
      return this.projectData;
    },
    formValid() {
      return {
        name: [
          { required: true, message: this.$t('message.newConst.enterName'), trigger: 'blur' },
          { message: `${this.$t('message.newConst.nameLength')}200`, max: 200 },
          { type: 'string', pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: this.$t('message.newConst.validNameDesc'), trigger: 'blur' },
        ],
        description: [
          { required: true, message: this.$t('message.project.pleaseInputProjectDesc'), trigger: 'blur' },
        ],
        product: [
          { required: true, message: this.$t('message.project.selectProduct'), trigger: 'change' },
        ],
        applicationArea: [
          { required: true, message: this.$t('message.project.selectAppArea'), trigger: 'change', type: 'number' },
        ]
      }
    }
  },
  mounted() {
    api.fetch('/dss/listApplicationAreas', 'get').then((res) => {
      this.applicationAreaMap = res.applicationAreas
    })
  },
  watch: {
    addProjectShow(val) {
      this.ProjectShow = val;
    },
    ProjectShow(val) {
      if (val) {
        this.originBusiness = this.projectDataCurrent.business;
      }
      this.$emit('show', val);
    },
  },
  methods: {
    // 打开新建预警用户窗口
    addWarningUser(){
      this.warningUserModal = true;
      this.addWarningUserFlag = true;
      this.updateWarningUserIndex = -1;
      this.warningUserInfo = {};
      // 查用户授权中审批通过的人员
      api.fetch('/acl/approve/permission/workspace', { status:'1', page:1, size:1000, }, 'get').then((res) => {
        console.log(res);
        this.userIds = [];
        res.data.list.map((item)=>{
            let ids = this.userIds.filter((id)=> id==item.applicant );
            if(!ids || ids.length==0){
                this.userIds.push(item.applicant);
            }
        });

      }).catch(() => {
        this.$Message.error("获取授权用户失败");
        
      });

    },
    // 打开编辑预警用户窗口
    editWarningUser(row,index){
      this.warningUserModal = true;
      this.addWarningUserFlag = false;
      this.updateWarningUserIndex = index;
      this.warningUserInfo = row;
    },
    deleteWarningUser(row,index){
      this.warningUserData.splice(index,1);
    },
    Ok() {
      this.$refs.projectForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.projectDataCurrent);
          this.ProjectShow = false;
        } else {
          this.$Message.warning(this.$t('message.newConst.failedNotice'));
        }
      });
    },
    Cancel() {
      this.ProjectShow = false;
      this.projectData.business = this.originBusiness;
    },
    addTag(label) {
      if (this.projectDataCurrent.business) {
        this.projectDataCurrent.business += `,${label}`;
      } else {
        this.projectDataCurrent.business = label;
      }
    },
    deleteTag(label) {
      const tmpArr = this.projectDataCurrent.business.split(',');
      const index = tmpArr.findIndex((item) => item === label);
      tmpArr.splice(index, 1);
      this.projectData.business = tmpArr.toString();
    },
    warningUserCancel(){
      this.warningUserModal = false;
      this.warningUserInfo = {};
      this.addWarningUserFlag = false;
    },
    warningUserConfirm(){
      this.$refs.warningUserForm.validate((valid) => {
        if (valid) {
          
          if(this.updateWarningUserIndex>-1){
            // 修改
            this.warningUserData.splice(this.updateWarningUserIndex,1,this.warningUserInfo);

          }else{
            // 新建
            this.warningUserData.push(this.warningUserInfo);
          }

          console.log(JSON.stringify(this.warningUserData));
          // this.warningUserModal = false;
          // this.warningUserInfo = {};
          // this.addWarningUserFlag = false;


          
        } else {
          this.$Message.warning(this.$t('message.newConst.failedNotice'));
        }
      });

    }
  },
};
</script>
<style >
.tblUptPadding .ivu-table-cell {
    padding-left: 8px;
    padding-right: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    box-sizing: border-box;
}
.a-margin-right{
  margin-right: 5px;
}

.tblUptPadding td.ivu-table-expanded-cell {
    padding: 8px 20px;
    background: #f8f8f9;
}


</style>